module.exports = __webpack_public_path__ + "static/media/other.3502496d.jpg";